<hunters-banner-component></hunters-banner-component>
<div id="planthunter">
  <div class="row">
    <div class="col-12 col-sm-12">
      <div>
        <article>
          <hunters-intro-component></hunters-intro-component>
          <planthunter-overview-component
            [planthunterDetailURL]="getHuntersDetailUrl()"
          ></planthunter-overview-component>
        </article>
      </div>
    </div>
  </div>
</div>
